<h1 mat-dialog-title class="h3">Edit Template</h1>
<div mat-dialog-content>
  <div class="file-name mb-2">
    <label class="h3 fs-16 mb-1">File Name</label>
    <input type="text" class="form-control h5" [value]="data.name" (blur)="changeFileName($event)">
  </div>
  <div class=description>
    <label class="h3 fs-16 mb-1">Description</label>
    <textarea type="text" class="form-control h5" [value]="data.templateDescription"
      (blur)="changeDescriprion($event)"></textarea>
  </div>

</div>
<div class="justify-content-end mat-dialog-actions" mat-dialog-actions="" style="padding-top: 10px;">
  <button mat-dialog-close  class="btn custom_btn inverted_btn_base">Cancel</button>
  <button  [mat-dialog-close]="data" class="btn custom_btn primary_btn_base ml-2">Update</button>
</div>
